<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">注册时间:<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.beginTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.endTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.name"  name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机姓名：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.phone"  name="start-date"></span>
				</div>
			</div>
			<div class="order-query-form-box">
				<label for="start-date">订单状态：</label>
				<span class="order-query-form-input">
					<el-select v-model="orderForm.marginStatus" placeholder="请选择" class="stSetSelect">
						<el-option
						v-for="item in marginStatusList"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</span>
			</div>
			<div class="order-query-form-box">
				<label for="start-date">认证状态：</label>
				<span class="order-query-form-input">
					<el-select v-model="orderForm.auditState " placeholder="请选择" class="stSetSelect">
						<el-option
						v-for="item in auditStateList"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</span>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:loading="loading"
				:showPage="togglePage"
				:showSummary="true" 
				:count-data="dataTotal"
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
				
			</common-table>
			
		</div>
	</div>
</template>
<script>
export default {
	name: 'DriverAccount',
	props: [],
	components: {},
	data(){
		return{
			tableColumns:[
				{
					title:'司机名称',
					key:'name',
				},{
					title:'司机手机',
					key:'phone',
				},
				{
				
					key:'auditStateDesc',
					title:'认证状态',
				},{
					title:'钱包余额',
					key:'amount',
				},{
					title:'收入',
					key:'incomeAmount',
				},{
					title:'提现',
					key:'withdrawAmount',
				},{
					title:'注册时间',
					key:'createTime',
				}
			],
			loading:false,
			bottomHandleArr:[
				{
					label: '导出',
					type: 'success',
					handler: () => this.exportTable()
				},
			],
			pageConfig: {
				total: 0,
				pageSize: 100,
				currentPage: 1,
			},
			dataList:[], //订单列表
			dataTotal: {},
			orderForm:{
				beginTime: null, //	注册	string	格式：yyyy-MM-dd HH:mm:ss
				endTime: null, //	注册	string	格式：yyyy-MM-dd HH:mm:ss
				marginStatus: 0, //	保证金状态	number	0=未缴纳、1=已缴纳、2=申请退回、3=已拒绝、4=已退回
				name: null, //	司机姓名	string	
				phone: null, //	司机手机	string	
				auditState:'UNAUTHORIZED'
			},
			
			togglePage:false, //是否显示分页
			selDriverId:null, //选中的司机
			selectedList:[],// 选中的列表
			driverList:[],// 司机列表
			toggleStDialog:false,// 弹窗
			marginStatusList:[{
					value: 0,
					label: '未缴纳'
				}, {
					value: 1,
					label: '已缴纳'
				}, {
					value: 2,
					label: '申请退回'
				},{
					value: 3,
					label: '已拒绝'
				},{
					value: 4,
					label: '已退回'
			}],
			auditStateList:[
				{
					value: 'UNAUTHORIZED',
					label: '未认证'
				},{
					value: 'PROCESSING',
					label: '审核中'
				},{
					value: 'REFUSE',
					label: '未通过'
				},{
					value: 'APPROVE',
					label: '已通过'
				}
			]
		}
	},
	created() {
		
	},
	methods: {
		sizeChange(size) {
			this.pageConfig.currentPage = 1
			this.pageConfig.pageSize = size
			this.searchList()
		},
		currentChange(currentPage) {
			this.pageConfig.currentPage = currentPage
			this.searchList()
      	},
		getSummaries(param) {
			// 处理合计不显示问题
			this.$nextTick(() => {
				this.$refs.table.doLayout();
			});
			let vm = this;
			let sums = [];
			var selectedColm = param.columns;
			let newArray = []
			selectedColm.forEach(a => {
				if (vm.dataTotal[a.property]) {
				newArray.push(vm.dataTotal[a.property])
				} else {
				newArray.push('')
				}
				
			});
			sums = newArray;
			sums[0] = "合计";
			return sums;
		},
		cellClass(row){     
			if (row.columnIndex === 0) {           
				return 'disabledCheck'     
			} 
		},
		selectionChange(val){
			this.selectedList=val;
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.loading=true;
			this.$server.financial.getDriverAccountCount(orderForm, (res) => {
				this.dataTotal = res.data

			})
			this.$server.financial.accountPage(orderForm,(res)=>{
				this.loading=false
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
				}

			})
		},
		// 导出
		exportTable(){
			let that = this;
			if (this.dataList.length < 1) {
			that.$toast.stMessage('暂无订单', true)
			return;
			}
			let pages = {};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			const sendData = {
				...this.orderForm,
				exportColumnFiledNames:  this.tableColumns.map((item) => {
						return item.slotName || item.key
					}).filter(item => {
						return item && item.trim()
					})
			}
			sendData.beginTime = sendData.beginTime ? new Date(sendData.beginTime).getTime() : ''
			sendData.endTime = sendData.endTime ? new Date(sendData.endTime).getTime() : ''
			Object.assign(sendData, pages)
			this.$server.common.exportTable('/finance/account-page-export', sendData, (res) => {
			console.log('导出成功')
			})
			
		},
	},
	mounted() {
		
	}
}

</script>
<style scoped>

.driver-account {
  width: 100%;
  height: auto;
}
.data-table-box {
	/* display: flex;
	justify-content: center;
	align-items: center; */
    height: auto;
    background: #FFF;
    padding: 8px;
	box-sizing: border-box;
	text-align: center;
}	
.data-table-warp{
	/* display: inline-block; */
	width: auto;
	margin: 0 auto;
}
.data-table{
	margin-bottom: 8px;
	/* border: 1px solid #ccc; */
}
.query-setting-box-left{
    flex-grow: 0;
}
</style>
